import { Injectable, Inject, Optional } from '@angular/core';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { Router } from '@angular/router';
import * as express from './express-ssr';
@Injectable() 
export class Redirection {
    constructor(
        @Inject(REQUEST) @Optional()
        private request : express.ExpressRequest,
        @Inject(RESPONSE) @Optional()
        private response : express.ExpressResponse,
        private router : Router
    ) {

    }

    go(url : string) {

        if (!url)
            return;

        let fromUrl = this.router.routerState.snapshot.url;

        console.log(` >>> Sent to ${url} (from ${fromUrl})`);
        
        let external = /^https?:/.test(url) || /^\/\//.test(url);

        if (external) {
            // External link    

            if (this.response) {
                if (this.response.headersSent) {
                    console.error(`Failed to redirect to '${url}': Headers already sent.`);
                    return;
                }
                this.response.redirect(url);
            } else if (typeof window !== 'undefined') {
                window.location.assign(url);
            } else {
                console.error(` x Cannot redirect to '${url}': No viable redirect mechanism is available.`);
            }
        } else {
            // Internal link.

            if (typeof window !== 'undefined') {
                this.router.navigateByUrl(url, {
                    replaceUrl: true
                });
            } else {
                if (this.response.headersSent) {
                    console.error('Failed to redirect: Headers already sent.');
                    return;
                }
                this.response.redirect(url);
            }
        }
    }
}
